import { render } from "./AddToFavoriteModal.vue?vue&type=template&id=4c370b93"
import script from "./AddToFavoriteModal.vue?vue&type=script&setup=true&lang=js"
export * from "./AddToFavoriteModal.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "/codebuild/output/src3003388635/src/git-codecommit.ap-northeast-1.amazonaws.com/v1/repos/portal-dev-frontend/vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/pages/components/templates/orderCart/modal/AddToFavoriteModal.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "4c370b93"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('4c370b93', __exports__)) {
    console.log('reload')
    api.reload('4c370b93', __exports__)
  }
  
  module.hot.accept("./AddToFavoriteModal.vue?vue&type=template&id=4c370b93", () => {
    console.log('re-render')
    api.rerender('4c370b93', render)
  })

}


export default __exports__